import React from "react";
import indiaFlag from "../../../assets/flag-india.png";
import cameroonFlag from "../../../assets/flag-cameroon.png";
import togoFlag from "../../../assets/flag-togo.png";

export default function ProductProducerCard() {
  return (
    <>
      <div className="ppc-wrap">
        <div className="ppc-card">
          <div className="ppc-block">
            <h3>Producteur</h3>

            <div className="ppc-name">Yikodeen</div>

            <div className="ppc-text">
              Plot No 278, Gurgaon Industrial Area,
              <br />
              Haryana 122001
            </div>

            <div className="ppc-country-line">
              <span>Inde</span>
              <img src={indiaFlag} alt="Inde" className="ppc-flag-img" />
            </div>

            <div className="ppc-text ppc-email">yikodeen@example.co.in</div>
          </div>

          <div className="ppc-divider" />

          <div className="ppc-block">
            <h3>Exportateurs ›</h3>

            <div className="ppc-person-line">
              <span className="ppc-check">◉</span>
              <span>Sunagro Exports Nigria</span>
            </div>

            <div className="ppc-sub">Depuis le 06.04.2026 à 15:1144</div>
          </div>

          <div className="ppc-divider" />

          <div className="ppc-block">
            <h3>Importateurs ›</h3>

            <div className="ppc-person-line">
              <span className="ppc-check">◉</span>
              <span>Ets Nkembe</span>
              <img
                src={cameroonFlag}
                alt="Cameroun"
                className="ppc-flag-img small"
              />
              <span className="ppc-country-name">Cameroun</span>
            </div>

            <div className="ppc-tags">
              <span className="tag orange">Dossier en attente</span>
              <span className="tag red">Certificat expirant</span>
            </div>

            <div className="ppc-person-line second">
              <span className="ppc-check">◉</span>
              <span>Yu Emis Tries</span>
              <img
                src={togoFlag}
                alt="Togo"
                className="ppc-flag-img small"
              />
              <span className="ppc-country-name">Togo</span>
            </div>

            <div className="ppc-corridor">
              Corridor autorisé : Tiko / Ø Idénau
            </div>
          </div>
        </div>

        <div className="ppc-footer-card">
          <span>Voir importateurs liés</span>
          <span className="ppc-footer-arrow">›</span>
        </div>
      </div>

      <style>{`
        .ppc-wrap {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .ppc-card,
        .ppc-footer-card {
          border-radius: 16px;
          overflow: hidden;
          background: linear-gradient(180deg, rgba(28,38,73,0.96), rgba(20,28,55,0.96));
          border: 1px solid rgba(255,255,255,0.07);
          box-shadow: 0 14px 32px rgba(0,0,0,0.24);
        }

        .ppc-block {
          padding: 15px 18px;
        }

        .ppc-divider {
          height: 1px;
          background: rgba(255,255,255,0.06);
        }

        .ppc-block h3 {
          margin: 0 0 12px;
          color: #f2f6ff;
          font-size: 17px;
          font-weight: 500;
          line-height: 1.3;
        }

        .ppc-name {
          color: #ffffff;
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 10px;
          line-height: 1.2;
        }

        .ppc-text,
        .ppc-country-line,
        .ppc-sub,
        .ppc-person-line {
          color: #d8e2ff;
          font-size: 15px;
          line-height: 1.5;
        }

        .ppc-country-line {
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 14px 0 12px;
        }

        .ppc-email {
          margin-top: 6px;
        }

        .ppc-flag-img {
          width: 22px;
          height: 15px;
          object-fit: cover;
          border-radius: 2px;
          display: inline-block;
          box-shadow: 0 0 0 1px rgba(255,255,255,0.08);
        }

        .ppc-flag-img.small {
          width: 18px;
          height: 13px;
        }

        .ppc-person-line {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .ppc-check {
          color: #78ba86;
          font-size: 11px;
          line-height: 1;
          display: inline-block;
          transform: translateY(-1px);
        }

        .ppc-country-name {
          color: #d8e2ff;
        }

        .ppc-sub {
          color: #aebad9;
          margin-top: 6px;
          margin-left: 19px;
          font-size: 14px;
        }

        .ppc-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 10px 0 12px 19px;
        }

        .tag {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 6px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 700;
          line-height: 1;
        }

        .tag.orange {
          background: rgba(223,154,73,0.18);
          border: 1px solid rgba(223,154,73,0.30);
          color: #fff2d9;
        }

        .tag.red {
          background: rgba(217,88,88,0.20);
          border: 1px solid rgba(217,88,88,0.34);
          color: #ffe8e8;
        }

        .ppc-person-line.second {
          margin-bottom: 14px;
        }

        .ppc-corridor {
          background: rgba(88, 141, 118, 0.11);
          border: 1px solid rgba(88, 141, 118, 0.18);
          color: #ecfff2;
          border-radius: 10px;
          padding: 10px 14px;
          font-size: 15px;
          line-height: 1.35;
          margin-left: 19px;
        }

        .ppc-footer-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 18px;
          color: #dfe7ff;
          font-size: 15px;
          background: linear-gradient(180deg, rgba(28,38,73,0.88), rgba(20,28,55,0.88));
        }

        .ppc-footer-arrow {
          opacity: 0.9;
        }

        @media (max-width: 760px) {
          .ppc-block {
            padding: 14px 16px;
          }

          .ppc-block h3 {
            font-size: 16px;
          }

          .ppc-name {
            font-size: 17px;
          }

          .ppc-text,
          .ppc-country-line,
          .ppc-sub,
          .ppc-person-line,
          .ppc-corridor,
          .ppc-footer-card {
            font-size: 14px;
          }

          .ppc-sub,
          .ppc-tags,
          .ppc-corridor {
            margin-left: 18px;
          }
        }
      `}</style>
    </>
  );
}